import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/lib/store";
import { AnnouncementBar } from "@/components/layout/AnnouncementBar";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Wishlist from "@/pages/Wishlist";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Collections from "@/pages/Collections";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StoreProvider>
          <AnnouncementBar/>
          <Navbar/>
          <CartDrawer/>
          <main>
            <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="/shop" element={<Shop/>}/>
              <Route path="/shop/:category" element={<Shop/>}/>
              <Route path="/product/:slug" element={<Product/>}/>
              <Route path="/collections" element={<Collections/>}/>
              <Route path="/collections/:slug" element={<Collections/>}/>
              <Route path="/wishlist" element={<Wishlist/>}/>
              <Route path="/checkout" element={<Checkout/>}/>
              <Route path="/order/:id" element={<OrderConfirmation/>}/>
              <Route path="/payment/success" element={<PaymentSuccess/>}/>
              <Route path="/payment/cancel" element={<PaymentCancel/>}/>
              <Route path="/auth" element={<Auth/>}/>
              <Route path="/account" element={<Account/>}/>
              <Route path="/about" element={<About/>}/>
              <Route path="/contact" element={<Contact/>}/>
              <Route path="/admin" element={<Admin/>}/>
            </Routes>
          </main>
          <Footer/>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{ style: { background: "#1C130E", border: "1px solid rgba(212,175,55,0.3)", color: "#FAF8F5" } }}
          />
        </StoreProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
